var exports = {
  "ProductUI": "ProductUI__g-oruh",
  "ProductUI__surface": "ProductUI__surface__yxv55U",
  "ProductUI--green": "ProductUI--green__mVwCd5",
  "ProductUI--blueLight": "ProductUI--blueLight__f2Xc3P",
  "ProductUI--blueDark": "ProductUI--blueDark__MSXaIc",
  "ProductUI--orange": "ProductUI--orange__i_LaoC",
  "ProductUI--pink": "ProductUI--pink__EqGzlX",
  "ProductUI--shadow-left": "ProductUI--shadow-left__2DOO2a",
  "ProductUI--shadow-left-bottom": "ProductUI--shadow-left-bottom__3TvoCr",
  "ProductUI--topLeftSquare": "ProductUI--topLeftSquare__9AZifx",
  "ProductUI--topRightSquare": "ProductUI--topRightSquare__aPTW8A",
  "ProductUI--bottomRightSquare": "ProductUI--bottomRightSquare__XzVttS",
  "ProductUI--bottomLeftSquare": "ProductUI--bottomLeftSquare__DoMP14",
};

__webpack_require__.r(module.exports = exports);
